import React, { cloneElement } from 'react'
import PropTypes from 'prop-types'

import styles from './select-vehicle.module.css'

const GenerationChoose = ({ children, intl }) => {
    return (
        <div id="generation-choose-box" className={styles['generation-choose-container']}>
            {children.map(c => {
                return cloneElement(c, { intl: intl })
            })}
        </div>
    )
}

GenerationChoose.propTypes = {
    intl: PropTypes.objectOf(PropTypes.func)
}

export { GenerationChoose }
